import { defineComponent, computed, ref, watch } from "vue";
export default defineComponent({
    props: {
        // 主标题
        title: {
            type: String,
            default: ""
        },
        // 副标题
        subtitle: {
            type: String,
            default: ""
        },
        // 弹窗显隐
        visible: {
            type: Boolean,
            default: false
        },
        // 确认按钮文案
        submitTitle: {
            type: String,
            default: ""
        },
        materialType: {
            type: Number
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var dialogVisible = computed({
            get: function() {
                return props.visible;
            },
            set: function(val) {
                emit("update:visible", val);
            }
        });
        var interactiveValue = ref(null);
        var handleClose = function() {
            emit("update:visible", false);
        };
        var handleCancel = function() {
            handleClose();
        };
        var handleSubmit = function() {
            var getMaterialType = function() {
                if (interactiveValue.value === 1) {
                    return 1;
                } else if (interactiveValue.value === 2 && (!props.materialType || props.materialType <= 2)) {
                    return 2;
                }
                return props.materialType;
            };
            emit("submit", getMaterialType());
            handleClose();
        };
        watch(function() {
            return props.visible;
        }, function(val) {
            if (val) {
                interactiveValue.value = props.materialType === 1 ? 1 : 2;
            } else {
                emit("cancel");
            }
        });
        return {
            dialogVisible: dialogVisible,
            interactiveValue: interactiveValue,
            handleClose: handleClose,
            handleCancel: handleCancel,
            handleSubmit: handleSubmit
        };
    }
});
